
<div>
    <app-bar :title="t('notifications_title')"></app-bar>

    <v-layout>
        <notification-collection></notification-collection>
    </v-layout>
</div>
